import axios from 'axios'
import store from '@/store'

const booksApi = axios.create({
  baseURL: '',
  headers: { Accept: 'application/json' },
})

booksApi.interceptors.request.use(
  (config) => {
    const token = store.state.auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

booksApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        await store.dispatch('auth/refreshToken')
        return booksApi(originalRequest)
      } catch (refreshError) {
        store.dispatch('auth/logout')
        return Promise.reject(refreshError)
      }
    }
    return Promise.reject(error)
  },
)

export default {
  getAllPost() {
    return booksApi.get('/api/books/post')
  },
  getPostByID(id) {
    return booksApi.get(`/api/books/post/${id}`)
  },
  addPost(formData) {
    return booksApi.post('/api/books/post/', formData)
  },
  updatePost(id, formData) {
    return booksApi.patch(`/api/books/post/${id}`, formData)
  },
  deletePost(id) {
    return booksApi.delete(`/api/books/post/${id}`)
  },
  toggleFavorite(id) {
    return booksApi.patch(`/api/books/post/${id}/favorite`)
  },
  moveToCollection(id) {
    return booksApi.patch(`/api/books/post/${id}/collection`)
  },
  search(search) {
    return booksApi.get('/api/books/search', { params: { search } })
  },
}
